import React from "react"
import {
  FaFacebook,
  FaLinkedin,
  FaWhatsapp,
  FaSkype,
  FaEnvelope,

} from "react-icons/fa"

const data = [
  {
    id: 1,
    icon: <FaFacebook className="social-icon"></FaFacebook>,
    url: "https://www.facebook.com/LetsMakeEverythingEasy/",
  },
  {
    id: 2,
    icon: <FaLinkedin className="social-icon"></FaLinkedin>,
    url: "#",
  },
  {
    id: 3,
    icon: <FaWhatsapp className="social-icon"></FaWhatsapp>,
    url: "https://wa.me/8801684635859",
  },
  {
    id: 4,
    icon: <FaSkype className="social-icon"></FaSkype>,
    url: "https://www.twitter.com",
  },
   {
    id: 5,
    icon: <FaEnvelope className="social-icon"></FaEnvelope>,
    url: "mailto:hscdojo.bd@gmail.com?subject=Project Inquiry",
  },
  
]
const links = data.map(link => {
  return (
    <li key={link.id}>
      <a href={link.url} className="social-link" target="_blank">
        {link.icon}
      </a>
    </li>
  )
})

export default ({ styleClass }) => {
  return (
    <ul className={`social-links ${styleClass ? styleClass : ""}`}>{links}</ul>
  )
}
